var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useRef } from 'react';
import styled from 'styled-components';
var RevealEvent = /** @class */ (function () {
    function RevealEvent(type, curtainElemRef, revealContentElemRef) {
        this.type = type;
        this.curtainElemRef = curtainElemRef;
        this.revealContentElemRef = revealContentElemRef;
    }
    return RevealEvent;
}());
export { RevealEvent };
var RevealOverlay = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  pointer-events: all;\n  overflow: hidden;\n"], ["\n  position: relative;\n  pointer-events: all;\n  overflow: hidden;\n"])));
var RevealCurtain = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-radius: 50%;\n  overflow: hidden;\n"], ["\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-radius: 50%;\n  overflow: hidden;\n"])));
var RevealContent = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  min-width: 500px;\n"], ["\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  min-width: 500px;\n"])));
export var Reveal = function (_a) {
    var children = _a.children, _b = _a.contentMinWidth, contentMinWidth = _b === void 0 ? 500 : _b, onChange = _a.onChange, _c = _a.reveal, reveal = _c === void 0 ? false : _c, revealContent = _a.revealContent, revealCurtainContent = _a.revealCurtainContent, _d = _a.revealPosition, revealPosition = _d === void 0 ? 'top left' : _d, _e = _a.speed, speed = _e === void 0 ? 'normal' : _e;
    var forward = useRef(false);
    var animating = useRef(reveal);
    var opened = useRef(reveal);
    var revealCurtainRef = useRef(null);
    var revealOverlayRef = useRef(null);
    var revealContentRef = useRef(null);
    var globalID = useRef(-1);
    var sizeRef = useRef(1);
    // animation logic inspired by https://github.com/nosachamos/react-circular-reveal
    var calculateSize;
    switch (speed) {
        case 'very slow':
            calculateSize = function (size, isOpening) {
                return isOpening ? size + Math.max(size / 15, 1) : size - Math.max(size / 15, 1);
            };
            break;
        case 'slow':
            calculateSize = function (size, isOpening) {
                return isOpening ? size + Math.max(size / 6, 2) : size - Math.max(size / 6, 2);
            };
            break;
        case 'normal':
            calculateSize = function (size, isOpening) {
                return isOpening ? size + Math.max(size / 3, 5) : size - Math.max(size / 3, 5);
            };
            break;
        case 'fast':
            calculateSize = function (size, isOpening) {
                return isOpening ? size + Math.max(size / 3, 20) : size - Math.max(size / 3, 20);
            };
            break;
        default:
            // eslint-disable-next-line no-console
            console.error('Reveal: Invalid value for speed.');
    }
    var animateCurtain = function () {
        if (revealCurtainRef.current && revealOverlayRef.current && revealContentRef.current) {
            var size = sizeRef.current;
            var curtainStyle = revealCurtainRef.current.style;
            var revealCurtainStyle = revealContentRef.current.style;
            var overlayRect = revealOverlayRef.current.getBoundingClientRect();
            var overlayWidth = overlayRect.width;
            var maxCircularSize = Math.max(overlayRect.height, overlayRect.width) * 2.5;
            curtainStyle.width = size + "px";
            curtainStyle.height = size + "px";
            revealCurtainStyle.minWidth = Math.min(overlayWidth, contentMinWidth) + "px";
            revealCurtainStyle.width = overlayWidth + "px";
            switch (revealPosition) {
                case 'top right':
                    curtainStyle.right = 0 - size / 2 + "px";
                    curtainStyle.top = 0 - size / 2 + "px";
                    curtainStyle.left = 'auto';
                    revealCurtainStyle.right = size / 2 + "px";
                    revealCurtainStyle.top = size / 2 + "px";
                    revealCurtainStyle.left = 'auto';
                    break;
                case 'bottom left':
                    curtainStyle.left = 0 - size / 2 + "px";
                    curtainStyle.bottom = 0 - size / 2 + "px";
                    curtainStyle.top = 'auto';
                    revealCurtainStyle.left = size / 2 + "px";
                    revealCurtainStyle.bottom = size / 2 + "px";
                    revealCurtainStyle.top = 'auto';
                    break;
                case 'bottom right':
                    curtainStyle.right = 0 - size / 2 + "px";
                    curtainStyle.bottom = 0 - size / 2 + "px";
                    curtainStyle.left = 'auto';
                    curtainStyle.top = 'auto';
                    revealCurtainStyle.right = size / 2 + "px";
                    revealCurtainStyle.bottom = size / 2 + "px";
                    revealCurtainStyle.left = 'auto';
                    revealCurtainStyle.top = 'auto';
                    break;
                case 'top left':
                default:
                    curtainStyle.left = 0 - size / 2 + "px";
                    curtainStyle.top = 0 - size / 2 + "px";
                    revealCurtainStyle.left = size / 2 + "px";
                    revealCurtainStyle.top = size / 2 + "px";
                    break;
            }
            if ((forward.current && size < maxCircularSize) || (!forward.current && size > 0)) {
                sizeRef.current = calculateSize(size, forward.current);
                globalID.current = requestAnimationFrame(animateCurtain);
            }
            else {
                animating.current = false;
                if (!forward.current) {
                    curtainStyle.width = '0px';
                    curtainStyle.height = '0px';
                }
                if (onChange) {
                    onChange(new RevealEvent(forward.current ? 'OPENED' : 'CLOSED', revealCurtainRef.current, revealContentRef.current));
                }
            }
        }
    };
    var doReveal = function () {
        animating.current = true;
        opened.current = !opened.current;
        if (onChange) {
            onChange(new RevealEvent(!forward.current ? 'OPENING' : 'CLOSING', revealCurtainRef.current, revealContentRef.current));
        }
        if (globalID.current !== -1) {
            cancelAnimationFrame(globalID.current);
            globalID.current = -1;
        }
        forward.current = !forward.current;
        animateCurtain();
    };
    if (reveal !== opened.current && !animating.current) {
        doReveal();
    }
    return (React.createElement(RevealOverlay, { ref: revealOverlayRef, className: "reveal-overlay", "data-testid": "reveal-overlay" },
        children,
        React.createElement(RevealCurtain, { ref: revealCurtainRef, className: "reveal-curtain", "data-testid": "reveal-curtain" },
            React.createElement(RevealContent, { ref: revealContentRef, className: "reveal-content", "data-testid": "reveal-content" }, revealContent),
            revealCurtainContent)));
};
export default Reveal;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map